import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx } from "vue";
import { listAll } from '@/api/system/role';
import { ROLE_STATUS } from '@/constant/system/code';

import { computed, ref, watch, onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'RoleSelect',
  props: {
    modelValue: {},
    value: {},
    labelKey: {
      default: 'roleName'
    },
    valueKey: {
      default: 'roleCode'
    },
    lazy: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const prop = __props;
    const selectValue = computed({
      get() {
        if (options.value.length === 0) {
          return '';
        }
        return prop.modelValue;
      },
      set(newVal) {
        emit('update:modelValue', newVal);
      }
    });
    const loading = ref(false);
    const options = ref([]);
    watch(() => prop.value, val => {
      selectValue.value = val;
    });
    onMounted(() => {
      if (prop.lazy) {
        loadRole();
      }
    });
    function handleFocus() {
      if (prop.lazy && !options.value) {
        loadRole();
      }
    }
    function refresh() {
      loadRole();
    }
    function loadRole() {
      if (loading.value) {
        return;
      }
      loading.value = true;
      listAll().then(result => {
        options.value = result.data;
      }).finally(() => {
        loading.value = false;
      });
    }
    function extractLabel(option) {
      return option[prop.labelKey];
    }
    function extractValue(option) {
      return option[prop.valueKey];
    }
    function isDisabled(option) {
      return option.status === ROLE_STATUS.DISABLED.CODE;
    }
    __expose({
      refresh
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(_component_el_select, {
        modelValue: _unref(selectValue),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(selectValue) ? selectValue.value = $event : null),
        loading: _unref(loading),
        multiple: _ctx.multiple,
        placeholder: "选择角色",
        onFocus: handleFocus
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), option => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: extractValue(option),
            label: extractLabel(option),
            value: extractValue(option),
            disabled: isDisabled(option)
          }, null, 8, ["label", "value", "disabled"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "loading", "multiple"]);
    };
  }
});